/* global TPDirect */
import React, { useEffect, useState } from 'react';
import preOrderAPI from '../preorder/api/preOrder';
import ProgressBackdrop from '../preorder/components/ProgressBackdrop';

export default (WrappedComponent) => (props) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);

    (async () => {
      try {
        const { paymentEnv } = await preOrderAPI.getInfo({});

        TPDirect.setupSDK(
          '13022',
          'app_SiAUC79o8FZEkRXDuvi9MH1xrIaH2JABAR3dFRQ6Kp7RbMqmYx56yxwzOngU',
          paymentEnv
        );
      } catch (e) {
        console.log('setup tappay fail');
      }

      setIsLoading(false);
    })();
  }, [setIsLoading]);

  return (
    <>
      <ProgressBackdrop isShow={isLoading} />
      <WrappedComponent {...props} />
    </>
  );
};
